// extracted by mini-css-extract-plugin
export var sectionAccesDirect = "index-module--section-acces-direct--2a21a";
export var sectionFirst = "index-module--section-first--fac3a";
export var sectionNePasManquer = "index-module--section-ne-pas-manquer--7aa49";
export var sectionPartenaires = "index-module--section-partenaires--d420f";
export var sectionSecond = "index-module--section-second--b6a1d";
export var sectionThird = "index-module--section-third--dedca";